// extracted by mini-css-extract-plugin
export default {"industryModel":"styles_industryModel__5KHto","boxModel":"styles_boxModel__U+r8h","cross":"styles_cross__7POsB"};